import React from 'react'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
import App from './App'
import './styles/global.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <Toaster
      position="top-right"
      containerStyle={{
        top: 'calc(16px + env(safe-area-inset-top))',
      }}
      toastOptions={{
        style: {
          background: '#1e293b',
          color: '#f1f5f9',
          border: '1px solid rgba(148, 163, 184, 0.1)',
          borderRadius: '12px',
          fontFamily: 'Inter, sans-serif',
          fontSize: '14px',
        },
        success: {
          iconTheme: { primary: '#10b981', secondary: '#1e293b' },
        },
        error: {
          iconTheme: { primary: '#ef4444', secondary: '#1e293b' },
        },
      }}
    />
  </React.StrictMode>,
)

// Ferramenta auxiliar de diagnóstico de responsividade e corte lateral
if (typeof window !== 'undefined') {
  (window as unknown as { checkOverflow: () => HTMLElement[] }).checkOverflow = () => {
    const docW = window.innerWidth;
    const offenders: HTMLElement[] = [];
    document.querySelectorAll('*').forEach((node) => {
      const el = node as HTMLElement;
      const rect = el.getBoundingClientRect();
      if (rect.width > 0 && rect.right > docW + 2) {
        offenders.push(el);
        el.style.outline = '2px solid #ef4444';
        el.style.outlineOffset = '-1px';
      }
    });
    // eslint-disable-next-line no-console
    console.warn(`[Overflow Detector] Encontrados ${offenders.length} elementos ultrapassando o viewport (${docW}px):`, offenders);
    return offenders;
  };
}

// Auto-atualização transparente do PWA após novos deploys
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistration().then((registration) => {
      if (registration) {
        // Checagem imediata ao iniciar o app
        registration.update().catch(() => {});

        // Checagem periódica a cada 15 minutos
        setInterval(() => {
          registration.update().catch(() => {});
        }, 15 * 60 * 1000);

        // Checagem automática ao retornar do background ou focar na janela
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            registration.update().catch(() => {});
          }
        });
      }
    }).catch(() => {});
  });
}

